import { Link, useNavigate } from 'react-router-dom';
import '../styles/pages/DashboardPage.css';
import { FaFileInvoice, FaImage, FaBook, FaBalanceScale, FaClipboardList, FaRobot, FaFileAlt, FaReceipt, FaCashRegister, FaLock, FaUsers, FaBuilding, FaCreditCard, FaQuestionCircle, FaHandshake, FaWallet, FaList, FaFileInvoiceDollar, FaSignOutAlt, FaBolt, FaInbox, FaUniversity } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const DashboardPage = ({ company }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="dash">
      <header className="dash-header">
        <div className="dash-header-top">
          <h1 className="dash-title">{company.name}</h1>
          <button onClick={handleLogout} className="dash-logout-btn">
            <FaSignOutAlt /> Cerrar sesión
          </button>
        </div>
        <p className="dash-sub">Panel de administración</p>
      </header>

      <section className="dash-section">
        <h2 className="dash-section-title">Compras</h2>
        <div className="dash-grid">
          <Card title="Carga facturas compra" link="/carga-compras" icon={<FaFileInvoice />} />
          <Card title="Carga imágenes boletas" link="/cargar-imagen" icon={<FaImage />} />
          <Card title="Gastos registrados por imágenes" link="/ver-gastos-pendientes" icon={<FaClipboardList />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Ventas</h2>
        <div className="dash-grid">
          <Card title="Carga facturas ventas" link="/carga-ventas" icon={<FaFileAlt />} />
          <Card title="Carga boletas" link="/cargar-boletas-sii" icon={<FaReceipt />} />
          <Card title="Carga ventas POS" link="/comprobante-pago" icon={<FaCashRegister />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Contabilidad</h2>
        <div className="dash-grid">
          <Card title="Ingreso asientos" link="/ingreso-manual" icon={<FaBook />} />
          <Card title="Visualizar balance" link="/ver-balance" icon={<FaBalanceScale />} />
          <Card title="Cierre mensual" link="/cierre-mensual" icon={<FaLock />} />
          <Card title="Cierre anual" link="/cierre-anual" icon={<FaLock />} />
          <Card title="Libro Caja SII" link="/libro-caja" icon={<FaWallet />} />
          <Card title="Libro Ingresos y Egresos SII" link="/libro-ingresos-egresos" icon={<FaList />} />
          <Card title="Conciliación Bancaria" link="/conciliacion-bancaria" icon={<FaUniversity />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Gestión</h2>
        <div className="dash-grid">
          <Card title="Automatización SII" link="/servicios-sii" icon={<FaRobot />} />
          <Card title="Arriendos" link="/arriendos" icon={<FaBuilding />} />
          <Card title="Recursos Humanos" link="/rrhh" icon={<FaUsers />} />
          <Card title="Socios empresa y Dividendos" link="/socios-dividendos" icon={<FaHandshake />} />
          <Card title="Patentes" link="/patentes" icon={<FaFileInvoiceDollar />} />
          <Card title="Acciones Rápidas" link="/acciones-rapidas" icon={<FaBolt />} />
          <Card title="Solicitudes de Clientes" link="/solicitudes" icon={<FaInbox />} />
        </div>
      </section>

      <section className="dash-section">
        <h2 className="dash-section-title">Configuración</h2>
        <div className="dash-grid">
          <Card title="Medios de pago" link="/credenciales-medios-pago" icon={<FaCreditCard />} />
          <a href="/manual-usuario.html" target="_blank" rel="noopener noreferrer" className="dash-card dash-card--highlight">
            <span className="dash-card-icon dash-card-icon--highlight"><FaQuestionCircle /></span>
            <span className="dash-card-label">Manual de usuario</span>

          </a>
        </div>
      </section>
    </div>
  );
};

const Card = ({ title, link, icon }) => (
  <Link to={link} className="dash-card">
    <span className="dash-card-icon">{icon}</span>
    <span className="dash-card-label">{title}</span>
  </Link>
);

export default DashboardPage;
